import { HttpContextToken } from '@angular/common/http';

/**
 * Opt a request out of the global error dialog.
 *
 * Screens that render a failure inline — the sign-in form, for one — would
 * otherwise show the same message twice, once inline and once as a modal
 * covering the form the user is trying to correct.
 */
export const SKIP_GLOBAL_ERROR = new HttpContextToken<boolean>(() => false);
